import { Banner } from "@/ui/Banner";
import { Button, Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";
import ExternalLink from "@/assets/ExternalLink.svg";

export const AboutPageBannerSection = ({ className }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.about.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.about.banner.image", src: "/assets/banners/default.png" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.about.banner.text.${locale}`} className="me-4" />
          <Button href="https://www.gravitasgroup.com" target="_blank" className="mt-3" variant="secondary" tabIndex={undefined}>
            <DynamicText path={`page.about.banner.button.${locale}`} />
            <ExternalLink className="ms-3" width="20" height="20" />
          </Button>
        </Col>
      </Row>
    </Banner>
  );
};
